<script>
import ControlTemp from "@/views/Control/Temp.vue"
import ControlLang from "@/views/Control/Lang.vue"
import axios from "@/axios";
import {mapActions, mapState} from "vuex";

export default {
  name: "View",
  mixins: [ControlTemp, ControlLang],
  data: () => ({
    // breadcrumb: [],
    stat_executed: null,
    stat_exec_url: 'statistic/exec',
  }),
  computed: {
    ...mapState('app', ['stat_user_id']),
  },
  methods: {
    ...mapActions('app', ['statUserIdSet']),
    async statExec(name, path) {

      console.log(name, path)

      let code = path.split('/').slice(-1);

      code = code[0];

      let data = {
        name: name, url: path, code: code,
        statistic_user_id: this.stat_user_id
      };

      console.log(data)

      let result_data = await axios.post(this.stat_exec_url, data).then(result => result.data.data)

      let stat_user_id = result_data.statistic_user_id;

      this.statUserIdSet(stat_user_id);

    },
    statExecLastBreadcrumb() {
      let breadcrumb_last = this.breadcrumb.slice(-1)[0];

      // console.log('Breadcrumb',this.breadcrumb)
      // console.log('Breadcrumb - Last',breadcrumb_last)

      this.statExec(breadcrumb_last.title, breadcrumb_last.link);
    },
  },
  mounted() {

  }
}
</script>